/*
  Drives every .origin-top-sale-bar__timer on the page.

  This logic used to live inline in sections/top-bar.liquid, which is not
  rendered anywhere on this site -- the header group ships promo-countdown-bar
  instead. So a Countdown Timer block on the product page produced the markup
  but nothing ever ticked it, and it sat at 00:00:00:00. Moving it into an asset
  lets any section or snippet that emits the markup pull in the behaviour.

  data-start is the cycle anchor, not a hard deadline: the countdown rolls
  forward in 7-day cycles from it, so a date in the past still counts down.
*/
(function () {
  var CYCLE = 7 * 24 * 60 * 60 * 1000;

  /* The promo bar in the header is the single source of truth for the campaign
     clock. It has its own start / end / repeat settings, and the product page
     timer used to run an unrelated weekly cycle off its own data-start -- so
     the two showed different numbers on the same screen (bar 05:08:11:37 while
     the PDP read 01:05:41:37).

     Mirroring the bar rather than copying its dates into a second set of
     settings: one campaign, one place to edit it, and they cannot drift. Falls
     back to the block's own cycle when no bar is on the page. */
  function promoBarTarget() {
    var bar = document.querySelector('[id^="CountdownBar-"][data-end]');
    if (!bar) return null;

    var start = new Date(bar.getAttribute('data-start'));
    var end = new Date(bar.getAttribute('data-end'));
    if (isNaN(start.getTime()) || isNaN(end.getTime()) || end <= start) return null;

    var repeatEnabled = bar.getAttribute('data-repeat-enabled') === 'true';
    var repeatDays = parseFloat(bar.getAttribute('data-repeat-days')) || 0;
    var repeatMs = repeatDays * 24 * 60 * 60 * 1000;
    var now = new Date();

    // Same rules as the bar's own getCurrentTarget().
    if (now < start) return null;
    if (now < end) return end.getTime();
    if (!repeatEnabled || repeatMs <= 0) return null;
    var cyclesElapsed = Math.ceil((now.getTime() - end.getTime()) / repeatMs);
    return end.getTime() + cyclesElapsed * repeatMs;
  }

  function start(timer) {
    // Several copies of this script can land on one page (the PDP renders a
    // mobile timer and a desktop timer), and the block markup is re-rendered
    // on variant change, so never bind the same node twice.
    if (timer.dataset.countdownBound === 'true') return;

    var startDate = new Date(timer.getAttribute('data-start')).getTime();
    if (isNaN(startDate)) return;

    var parts = {
      days: timer.querySelector('.days'),
      hours: timer.querySelector('.hours'),
      minutes: timer.querySelector('.minutes'),
      seconds: timer.querySelector('.seconds')
    };
    if (!parts.days || !parts.hours || !parts.minutes || !parts.seconds) return;

    timer.dataset.countdownBound = 'true';

    function nextEnd() {
      var fromBar = promoBarTarget();
      if (fromBar) return fromBar;

      var now = Date.now();
      if (now < startDate) return startDate + CYCLE;
      return startDate + (Math.floor((now - startDate) / CYCLE) + 1) * CYCLE;
    }

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var distance = Math.max(0, nextEnd() - Date.now());
      parts.days.textContent = pad(Math.floor(distance / 86400000));
      parts.hours.textContent = pad(Math.floor((distance / 3600000) % 24));
      parts.minutes.textContent = pad(Math.floor((distance / 60000) % 60));
      parts.seconds.textContent = pad(Math.floor((distance / 1000) % 60));
    }

    tick();
    setInterval(tick, 1000);
  }

  function init() {
    var timers = document.querySelectorAll('.origin-top-sale-bar__timer');
    Array.prototype.forEach.call(timers, start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The buy area re-renders on variant change, which brings back an unbound
  // timer node; pick it up without waiting for another page load.
  if (window.MutationObserver) {
    new MutationObserver(init).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
